import React from 'react'
import IconLabel from '../../common/icon-label'
import { Calendar3 } from 'react-bootstrap-icons'
import Date from '../../date/numerical'

const DateIconLabel = ({
    experience = {}
}) => {

    return (
        <IconLabel
            icon={Calendar3}
        >
            <Date value={experience.date} />
        </IconLabel>
    )
}

export default DateIconLabel